import createDOMPurify from 'dompurify';

export function purify(value) {
    const DOMPurify = createDOMPurify(window);

    return DOMPurify.sanitize(value);
}